import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 11.594V20.5h-15v-15h7.969m4.031-3h6v6m-9 3l9-9-9 9z" stroke="currentColor" fill="none" /></svg>;